<div class="title">{{'MOVEDLG.CHOOSE' | translate}}</div>

<div class="header">
  <asg-breadcrumbs [currentCloud]="currentCloud" (rootBreadcrumbClicked)="openRootFolder()"
  (breadcrumbClicked)="openFolder(MimeTypesEnum.Folder, true)"></asg-breadcrumbs>

  <form [formGroup]="formGroup">
    @if (!noCloudSelected) {
      <div class="w2c-columns is-vcentered">
        <div class="w2c-column fa-pull-right">
          <div class="custom-select">
            <i class="fas fa-angle-down"></i>
            <select formControlName="cloudFolders">
              @for (cloudFolder of cloudFolders; track cloudFolder) {
                <option [value]="cloudFolder">
                  {{currentCloudForNgx + '.' + cloudFolder | translate}}
                </option>
              }
            </select>
          </div>
        </div>
      </div>
    }
  </form>
</div>

<table class="table fixed_header">
  <tbody>
    @if (isLoading()) {
      <tr class="spinner-container">
        <asg-pure-spinner></asg-pure-spinner>
      </tr>
    } @else {
      @for (file of fileList; track file; let i = $index) {
        <tr (click)="selectedItem = file; singleClick($event);"
          (dblclick)="openFolder(selectedItem?.mimeType)" class="{{file.id}} + ' pointer'">
          <td>
            @if (file.mimeType === MimeTypesEnum.SharedDrive) {
              <i class="material-icons size">cloud</i>
            }
            @if (file.mimeType === MimeTypesEnum.Folder) {
              @if (!file.isShared) {
                <i class="material-icons size">folder</i>
              }
              @if (file.isShared) {
                <i class="material-icons size">folder_shared</i>
              }
            }
            @if (file.mimeType !== MimeTypesEnum.Folder) {
              @if (file.mimeType === MimeTypesEnum.ApplicationPdf) {
                <i class="material-icons size">picture_as_pdf</i>
              }
              @if (file.mimeType === MimeTypesEnum.ApplicationOctetStream) {
                <i
                class="material-icons size">file_copy</i>
              }
              @if (
                file.mimeType === MimeTypesEnum.TextRtf ||
                file.mimeType === MimeTypesEnum.ApplicationRtf ||
                file.mimeType === MimeTypesEnum.ApplicationMsWord ||
                file.mimeType === MimeTypesEnum.ApplicationMSWordOpenXML ||
                file.mimeType === MimeTypesEnum.ApplicationMsExcelOpenXML ||
                file.mimeType === MimeTypesEnum.ApplicationMsPptOpenXML) {
                <i class="material-icons size">reorder</i>
              }
              @if (file.mimeType === MimeTypesEnum.GoogleDriveShortcut) {
                <i class="fas fa-share-square"></i>
              }
            }
            @if (file.mimeType === MimeTypesEnum.Mp3) {
              <i class="material-icons size">audiotrack</i>
            }
          </td>
          <td class="name-cell">{{file.name}}</td>
        </tr>
      }
    }
    <ng-template #spinner>
      <tr class="spinner-container">
        <asg-pure-spinner></asg-pure-spinner>
      </tr>
    </ng-template>

  </tbody>
</table>

<div class="buttonContainer w2c-column">
  <p class="fa-pull-left hyperlink" (click)="doOperation(DialogOperationEnum.NewFolder)" asgTooltip="DIALOGS.NEWFOLDER"><i
  class="material-icons max-size">create_new_folder</i></p>
  <div class="bottom-right">
    <input type="submit" class="cb-btn fa-pull-right" value="{{'OPENSAVEDLG.CANCEL' | translate}}"
      (click)="returnToCloudStorage()" />
      @if (!isCopy) {
        <input type="submit" class="cb-btn" value="{{'OPENSAVEDLG.MOVE' | translate}}"
          (click)="pasteFile();" />
      }
      &nbsp;
      @if (isCopy) {
        <input type="submit" class="cb-btn top" value="{{'OPENSAVEDLG.COPY' | translate}}"
          (click)="pasteFile();" />
      }
    </div>
  </div>
